module.exports = __webpack_public_path__ + "img/_4.c31c3121.png";